import { useEffect } from "react";

const SITE = "https://verdecapital.eu";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertAlternate = (hreflang, href) => {
  let el = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
  if (!el) {
    el = document.createElement("link");
    el.rel = "alternate";
    el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.href = href;
};

export default function Seo({ title, description, path, lang = "en" }) {
  useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-PT" : lang === "nl" ? "nl-NL" : "en-GB";
    document.title = title;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `${SITE}${path}`;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", `${SITE}${path}`);
    upsertMeta("property", "og:locale", lang === "pt" ? "pt_PT" : lang === "nl" ? "nl_NL" : "en_GB");
    const ogAlternates = { en: "en_GB", pt: "pt_PT", nl: "nl_NL" };
    const alternates = Object.entries(ogAlternates).filter(([l]) => l !== lang);
    upsertMeta("property", "og:locale:alternate", alternates[0][1]);
    upsertMeta("property", "og:locale:alternate:1", alternates[1][1]);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    const base = lang === "en" ? path : path.replace(/^\/(pt|nl)/, "") || "/";
    upsertAlternate("en", `${SITE}${base}`);
    upsertAlternate("pt-PT", `${SITE}${base === "/" ? "/pt" : `/pt${base}`}`);
    upsertAlternate("nl-NL", `${SITE}${base === "/" ? "/nl" : `/nl${base}`}`);
    upsertAlternate("x-default", `${SITE}${base}`);
  }, [title, description, path, lang]);
  return null;
}
